import { useEffect, useRef } from 'react';
import { useLazyLoad } from './use-lazy-load';

const defaultPageSize = 10;
type LazyLoadGeneralParamValue = string | number | boolean | undefined;
type LazyLoadGeneralParams = Record<string, LazyLoadGeneralParamValue>;

export function useLazyLoadGeneral<T>(
  useLazyGet: (...args) => any,
  searchValue = '',
  pageSize = defaultPageSize,
  extraParams: LazyLoadGeneralParams = {},
) {
  const { items, footerRef, resetAll } = useLazyLoad(useLazyGet, {
    pageSize,
    searchValue,
    ...extraParams,
  });
  const previousQueryKeyRef = useRef<string>(
    JSON.stringify({ searchValue, extraParams }),
  );

  useEffect(() => {
    const queryKey = JSON.stringify({ searchValue, extraParams });
    if (queryKey !== previousQueryKeyRef.current) {
      previousQueryKeyRef.current = queryKey;
      resetAll(true);
    }
  }, [resetAll, searchValue, extraParams]);

  return { items: (items as T[] | null) ?? [], footerRef };
}
